module.exports = __webpack_public_path__ + "static/media/snoopyclearsky01.ce03ad44.gif";